<template>
    <div>
        <template v-if="order.third_party">
            <div class="card registrant-card" :class="{ 'border-danger': error }">
                <div class="card-header border-0">
                    <h4 class="card-title">
                        {{ registrant.first_name }} {{ registrant.last_name }}
                        <template v-if="registrant.self">
                            <span class="font-weight-normal ml-1 small text-muted">(moi-même)</span>
                        </template>
                    </h4>
                </div>

                <div class="card-body">
                    <slot />
                </div>
            </div>
        </template>
        <template v-else>
            <slot />
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            order: Object,
            registrant: Object,
            error: Boolean,
        },
    }
</script>
